export default __webpack_public_path__ + "static/media/logo-white-small.631f302a.svg";